import { Component, inject, ViewEncapsulation } from '@angular/core';
import { EnvironmentTypeEnum } from '@coin/importer/core/util';
import { environment } from '@coin/shared/core/util-environments';
import { UpdateNotificationsService } from '@coin/shared/core/util-helpers';

@Component({
  selector: 'importer-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderComponent {
  protected updateNotifications = inject(UpdateNotificationsService);

  get currentEnvironment() {
    return environment.type !== EnvironmentTypeEnum.Prod ? environment : null;
  }
}
